export default __webpack_public_path__ + "static/2-6-1-1-16ca1646d613849724678c8d8412e592.jpg";